import React from 'react'

import LABEL from '../../../business-const/Label/Label'

import {
    CLASSNAME
} from '../../../business-const/Style/Style'

import {
    formataTableCellHeadExibeDadosTexto,
    formataTableCellHeadExibeDadosValor,
    formataTableCellHeadExibeDadosValorQuebraEspecial,
    formataTableCellBodyExibeDadosTexto,
    formataTableCellBodyExibeDadosValor,
} from '../../../business-components/Formata/Formata'

import {
    DivFormEstudo,
} from '../../../business-components/Div/Div'

import {
    CardGridDivBody,
} from '../../../business-components/Card/Card'

import {
    GridContainerReport,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    TableExibeDados,
    TableHeadExibeDados,
    TableRowHeadExibeDados,
    TableBodyExibeDados,
    TableRowBodyExibeDados,
    TableCellBodyExibeDados,
} from '../../../business-components/Table/TableExibeDados'

import {
    calculaReport,
} from './EstudoService'



const EstudoFormNecessidadeAposentadoria = ( { values, estudo, report } ) => {

    const reportNecessidadeAposentadoria = calculaReport(values, report)
    
    const NecessidadeAposentadoria = () => {
    
        let headList = [
            {
                colSpan: 2,
                headTitle: formataTableCellHeadExibeDadosTexto(LABEL.idadeDe, reportNecessidadeAposentadoria),
            },
            {
                colSpan: 2,
                headTitle: formataTableCellHeadExibeDadosTexto(LABEL.idadeAte, reportNecessidadeAposentadoria),
            },
            {
                colSpan: 3,
                headTitle: formataTableCellHeadExibeDadosValor(LABEL.receitaAposentadoriaMensal, reportNecessidadeAposentadoria),
            },
            {
                colSpan: 3,
                headTitle: formataTableCellHeadExibeDadosValor(LABEL.despesaAposentadoriaMensal, reportNecessidadeAposentadoria),
            },
            {
                colSpan: 4,
                headTitle: formataTableCellHeadExibeDadosValorQuebraEspecial(LABEL.despesasExcedentesMensal, reportNecessidadeAposentadoria),
            },
        ]

        const espacoReduzido = estudo.current.necessidadeAposentadoria.length > 25 ? true : false

        return (
            <DivFormEstudo>
                <GridContainerReport>
                    <GridItem12
                        align="center"
                        className={'mb-2 '+ CLASSNAME().formataReportCapacidadePoupancaNecessidadeAporteAposentadoriaCabecalho}
                    >
                        {reportNecessidadeAposentadoria // mudança da fonte
                            ?
                                <>
                                    <div>
                                        {LABEL.necessidadeAposentadoria}
                                    </div>

                                    <div>
                                        {LABEL.necessidadeAposentadoriaDespesasNaoCobertas}
                                    </div>
                                </>
                            :
                                <>
                                    {LABEL.necessidadeAposentadoria + ' ' + LABEL.necessidadeAposentadoriaDespesasNaoCobertas}
                                </>
                        }
                    </GridItem12>
                </GridContainerReport>

                <CardGridDivBody>
                    <TableExibeDados
                        report={reportNecessidadeAposentadoria}
                        noMinW={true}
                    >
                        <TableHeadExibeDados>
                            <TableRowHeadExibeDados
                                dados={headList}
                            />
                        </TableHeadExibeDados>

                        <TableBodyExibeDados>
                            {estudo.current.necessidadeAposentadoria?.map((item, ind) => {
                                return (
                                    <TableRowBodyExibeDados
                                        key={ind}
                                        report={reportNecessidadeAposentadoria}
                                    >
                                        <TableCellBodyExibeDados
                                            colSpan={headList[0].colSpan}
                                            primeiraColuna={true}
                                            espacoReduzido={espacoReduzido}
                                        >
                                            {formataTableCellBodyExibeDadosTexto(item.idadeDe, reportNecessidadeAposentadoria)}
                                        </TableCellBodyExibeDados>
                                        
                                        <TableCellBodyExibeDados
                                            colSpan={headList[1].colSpan}
                                            espacoReduzido={espacoReduzido}
                                        >
                                            {formataTableCellBodyExibeDadosTexto(item.idadeAte, reportNecessidadeAposentadoria)}
                                        </TableCellBodyExibeDados>
                                        
                                        <TableCellBodyExibeDados
                                            colSpan={headList[2].colSpan}
                                            espacoReduzido={espacoReduzido}
                                        >
                                            {formataTableCellBodyExibeDadosValor(item.receitaAposentadoriaMensal,
                                                reportNecessidadeAposentadoria, false, true)}
                                        </TableCellBodyExibeDados>
                                        
                                        <TableCellBodyExibeDados
                                            colSpan={headList[3].colSpan}
                                            espacoReduzido={espacoReduzido}
                                        >
                                            {formataTableCellBodyExibeDadosValor(item.despesaAposentadoriaMensal,
                                                reportNecessidadeAposentadoria, false, true)}
                                        </TableCellBodyExibeDados>
                                        
                                        <TableCellBodyExibeDados
                                            colSpan={headList[4].colSpan}
                                            espacoReduzido={espacoReduzido}
                                        >
                                            {formataTableCellBodyExibeDadosValor(item.despesasExcedentesMensal,
                                                reportNecessidadeAposentadoria, false, true)}
                                        </TableCellBodyExibeDados>
                                    </TableRowBodyExibeDados>
                                )
                            })}
                        </TableBodyExibeDados>
                    </TableExibeDados>
                </CardGridDivBody>
            </DivFormEstudo>
        )
    }



    return (
        <NecessidadeAposentadoria/>
    )
}

export default EstudoFormNecessidadeAposentadoria